import { Disclosure } from "@headlessui/react";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { getProfile } from "../../api/api";
import circular_actv from "../../assets/images/circular_activities.png";
import IconButton from "../basic/IconButton";
import ShareDialog from "../home/ShareDialog";
import { SkeletonExerciseList } from "../playlistDialog/Exercise";
import "./custom.css";

function Activity({
  activityImage = "https://www.helpguide.org/wp-content/uploads/resistance-band-woman-doing-leg-workout-768.jpg",
  execisesName,
  date = "",
  exercisesDuration,
  exercisesReps,
  repDuration,
  resultAccuracy,
  resultCoins,
  badgeText,
  exercisesBenefits,
  exerciseURI,
  individualAvgs,
  doneOn,
  url,
  resultURL,
  resultId,
}) {
  console.log(exerciseURI);
  const ExerciseAverage = ({ name, percentage }) => {
    return (
      <div className="flex flex-row  items-center w-full space-x-5">
        <p className="font-bold text-primary-black dark:text-primary-white flex basis-1/2">
          {name}
        </p>
        <div className="flex flex-1 items-center w-full bg-primary-extraLightBlue h-3 rounded-md ">
          <div
            style={{
              width: `${percentage}%`,
              background:
                "linear-gradient(270deg, #EA2EFB 2.26%, #450BD5 136.45%)",
              transition: "width 500ms",
            }}
            className=" h-3 rounded-md"
          ></div>
        </div>
        <p className="text-primary-blue dark:text-primary-neonGreen basis-1/6 text-center">
          {percentage}%
        </p>
      </div>
    );
  };

  const [showShareDialog, setShowShareDialog] = useState(false);
  const [iconDetails, setIconDetails] = useState({});
  const percentage = 66;

  async function getProfileInfo() {
    let response = await getProfile();
    console.log(response);
    if (response) {
      setIconDetails(response);
    } else {
      // toast("Error fetching profile details", { type: "error" });
    }
  }

  useEffect(() => {
    getProfileInfo();
  }, []);

  return (
    <div className="mx-auto w-full rounded-xl">
      <Disclosure>
        {({ open }) => (
          <div className={`bg-[#1F1F1F]`}>
            <Disclosure.Button className="w-full text-left flex flex-col flex-1 items-center h-40 lg:h-64 rounded-xl">
              <ShareDialog
                show={showShareDialog}
                close={() => {
                  setShowShareDialog(false);
                }}
                // shareLink={`https://getactyv.com/exercise?routineId=${resultURL}`}
                shareLink={`https://getactyv.com/programpage?routineId=${resultURL}`}
                shareMessage={`Hey, I just finished a ${resultId} routine on getactyv.com. You can try it too and get active!`}
              />
              <div className="w-full">
                <div className="w-full flex lg:flex-row flex-col">
                  <img
                    src={activityImage}
                    className="h-40 lg:h-64 w-full bg-white object-cover"
                  />
                  <div className="w-full grid grid-rows-2">
                    <div className="flex flex-row justify-between px-4 py-4 ">
                      <div className="flex flex-col">
                        <p
                          className={`flex justify-center font-medium lg:text-xl text-[#FFFFFF]`}
                        >
                          {" "}
                          {execisesName}
                        </p>
                        {/* <p className='text-[#C4C4C4] text-xs font-light'>time</p> */}
                      </div>
                      <div className="">
                        <IconButton
                          iconComponent={
                            <Icon
                              icon="material-symbols:share-outline"
                              // className="flex md:h-6 md:w-6 text-white "
                              className="bg-[#111525] bg-opacity-50 justify-center h-7 w-7  z-10"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowShareDialog(true);
                              }}
                            />
                          }
                          className="bg-opacity-0 justify-center h-7 w-7  z-10"
                        />
                      </div>
                      {/* <div className="flex lg:ml-32 ml-16">
                                            <p className="text-primary-gray font-medium  lg:text-sm">
                                                {timestampToFormattedDate(doneOn)}
                                            </p>
                                        </div> */}
                    </div>
                    <div className="flex flex-row justify-around lg:px-12 lg:pb-0 pb-10 px-10">
                      <div className="flex flex-col">
                        <p className="flex justify-center">
                          <Icon
                            icon="ic:twotone-access-time-filled"
                            className="h-8 w-auto text-[#48B795]"
                          />
                        </p>
                        <p
                          className={`flex justify-center font-ligh text-center lg:text-lg text-md text-[#FFFFFF]`}
                        >
                          {iconDetails.timespent}
                        </p>
                      </div>

                      <div className="flex flex-col">
                        <p className="flex justify-center">
                          <Icon
                            icon="mdi:fire"
                            className="h-8 w-auto text-primary-orange"
                          />
                        </p>
                        <p className="flex justify-center font-ligh text-center lg:text-lg text-md text-[#FFFFFF]">
                          {iconDetails.calories}
                        </p>
                      </div>

                      <div className="flex flex-col">
                        <p className="flex justify-center text-xl text-[#FF0000] font-bold">
                          1
                        </p>
                        <p className="flex justify-center font-ligh text-center lg:text-lg text-md text-[#FFFFFF]">
                          move
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* {individualAvgs &&
                individualAvgs.length > 0 &&
                typeof individualAvgs == "object" && (
                  <div className="flex flex-row w-full justify-center items-center gap-4 bg-[#151515] py-4 ">
                    {(resultURL || resultId) && (
                      <a
                        href={
                          resultURL
                            ? resultURL
                            : `https://http://app.getactyvphysio.com/results/program/${resultId}`
                        }
                        className="flex self-end mt-5 md:mt-0"
                      >
                        <p className="text-[#AAA8A8] text-xs">Result Details</p>
                      </a>
                    )}
                    <Icon
                      icon={"akar-icons:chevron-down"}
                      className={`${
                        open ? "rotate-180 transform" : ""
                      } text-primary-black self-center dark:text-white place-self-start`}
                    />
                  </div>
                )} */}
            </Disclosure.Button>
            <Disclosure.Panel className="flex flex-col space-y-10 mt-5">
              {individualAvgs && individualAvgs?.length > 0 && (
                <div className="w-full text-left flex flex-col flex-1 items-center h-40 lg:h-64 rounded-xl">
                  <div
                    label="Default"
                    className="grid grid-rows-2 gap-20 w-full h-full px-10 py-10 rounded-xl"
                    style={{
                      backgroundImage: `url(${circular_actv})`,
                      backgroundSize: "cover",
                    }}
                  >
                    <div className="grid grid-cols-5 gap-10">
                      <div className="w-3/2">
                        <CircularProgressbar
                          value={percentage}
                          text={`${percentage}%`}
                        />
                        <p className="flex justify-center my-2 text-white text-sm font-medium">
                          Energy
                        </p>
                      </div>
                      <div className="w-3/2">
                        <CircularProgressbar value={percentage} text={"80%"} />
                        <p className="flex justify-center my-2 text-white text-sm font-medium">
                          Fat Burn
                        </p>
                      </div>
                      <div className="w-3/2">
                        <CircularProgressbar value={percentage} text={"9/10"} />
                        <p className="flex justify-center my-2 text-white text-sm font-medium">
                          Strength
                        </p>
                      </div>
                      <div className="w-3/2">
                        <CircularProgressbar value={percentage} text={"7/10"} />
                        <p className="flex justify-center my-2 text-white text-sm font-medium">
                          Flexibility
                        </p>
                      </div>
                      <div className="w-3/2">
                        <CircularProgressbar value={percentage} text={"4/10"} />
                        <p className="flex justify-center my-2 text-white text-sm font-medium">
                          Endurance
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-5 gap-10">
                      <div className="w-3/2">
                        <CircularProgressbar value={percentage} text={"80%"} />
                        <p className="flex justify-center text-white text-sm font-medium">
                          Speed
                        </p>
                      </div>
                      <div className="w-3/2">
                        <CircularProgressbar
                          value={percentage}
                          text={`${percentage}%`}
                        />
                        <p className="flex justify-center text-white text-sm font-medium">
                          Power
                        </p>
                      </div>
                      <div className="w-3/2">
                        <CircularProgressbar value={percentage} text={"9/10"} />
                        <p className="flex justify-center text-white text-sm font-medium">
                          Improvement
                        </p>
                      </div>
                      <div className="w-3/2">
                        <CircularProgressbar value={percentage} text={"7/10"} />
                        <p className="flex justify-center text-white text-sm font-medium">
                          Regularity
                        </p>
                      </div>
                      <div className="w-3/2">
                        <CircularProgressbar
                          value={percentage}
                          text={`${percentage}%`}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div className="flex flex-row w-full justify-start items-center gap-5 ">
                                <a
                                    href={`https://http://app.getactyvphysio.com/results/program/`
                                    }
                                    className="flex self-end mt-5 md:mt-0"
                                >
                                    <p className="text-white text-xs">Share</p>
                                </a>
                                <Icon
                                    icon={"akar-icons:ic_share"}
                                    className="rotate-180 transform text-[#FFFFFF]"
                                />
                            </div> */}
                  <ShareDialog
                    show={showShareDialog}
                    close={() => {
                      setShowShareDialog(false);
                    }}
                    shareLink={
                      resultURL
                        ? resultURL
                        : resultId
                        ? `https://app.getactyvphysio.com/results/program/${resultId}`
                        : `https://app.getactyvphysio.com/${exerciseURI}`
                    }
                    shareMessage={`Hey I practiced ${execisesName} on Getactyv today. Do check it out.`}
                  />
                  {!individualAvgs &&
                    typeof individualAvgs == "object" &&
                    !individualAvgs?.length > 0 && (
                      <div className="flex flex-col h-full">
                        {/* <Popover>
                                                <Popover.Button>
                                                    <Icon
                                                        icon={"carbon:overflow-menu-vertical"}
                                                        className={`h-6 w-6 text-primary-black dark:text-white place-self-start`}
                                                    />
                                                </Popover.Button>
                                                <Transition
                                                    as={Fragment}
                                                    enter="transition ease-out duration-200"
                                                    enterFrom="opacity-0 translate-y-0"
                                                    enterTo="opacity-100 translate-y-1"
                                                    leave="transition ease-in duration-150"
                                                    leaveFrom="opacity-100 translate-y-1"
                                                    leaveTo="opacity-0 translate-y-0"
                                                >
                                                    <Popover.Panel
                                                        className={`absolute z-20 w-40 mt-3 -ml-28 focus:outline-none flex flex-col ${WhiteLinearGradient} rounded-xl`}
                                                    >
                                                        <div className="flex flex-col">
                                                            <div
                                                                className="flex flex-row space-x-3 hover:bg-primary-white hover:dark:bg-primary-lightBlack p-3 rounded-t-xl"
                                                                onClick={() => setShowShareDialog(true)}
                                                            >
                                                                <Icon
                                                                    icon="ant-design:share-alt-outlined"
                                                                    className="h-6 w-auto dark:text-white"
                                                                />
                                                                <p className={`${BlackTextLinearGradient}`}>
                                                                    Share
                                                                </p>
                                                            </div>

                                                            <a
                                                                href={
                                                                    url ||
                                                                    `https://http://app.getactyvphysio.com/${exerciseURI}`
                                                                }
                                                            >
                                                                <div className="flex flex-row space-x-3 hover:bg-primary-white hover:dark:bg-primary-lightBlack p-3 rounded-b-xl">
                                                                    <Icon
                                                                        icon="jam:refresh-reverse"
                                                                        className="h-6 w-auto dark:text-white"
                                                                    />
                                                                    <p className={`${BlackTextLinearGradient}`}>
                                                                        Try Again
                                                                    </p>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </Popover.Panel>
                                                </Transition>
                                            </Popover> */}
                        <div className="flex flex-1"></div>
                      </div>
                    )}

                  {/* <div className="flex flex-row w-full justify-center items-center py-3  bg-[#D93942]">
                                    <a
                                        href={`https://http://app.getactyvphysio.com/results/program/`}
                                        className="flex self-end mt-5 md:mt-0"
                                    >
                                        <p className="text-white text-xs">See detailed result</p>
                                    </a>
                                    <Icon
                                        icon={"akar-icons:chevron-down"}
                                        className="rotate-180 transform text-[#FFFFFF]"
                                    />
                                </div> */}

                  {individualAvgs?.map((exercise, index) => {
                    return (
                      <ExerciseAverage
                        name={exercise.name}
                        percentage={exercise.per}
                        key={`${exercise.name}-${index}`}
                      />
                    );
                  })}
                </div>
              )}
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>
      {/* 
            <Disclosure>
                <div className="flex flex-col space-y-10 mt-5 md:px-20">

                    <Disclosure.Button
                        className="w-full text-left flex flex-col flex-1 items-center h-40 lg:h-64 rounded-xl"
                    >
                        <div
                            label="Default"
                            className="grid grid-rows-2 gap-20 w-full h-full px-10 py-10 rounded-xl"
                            style={{
                                backgroundImage: `url(${circular_actv})`,
                                backgroundSize: 'cover',
                            }}>
                            <div className='grid grid-cols-5 gap-10'>
                                <div className='w-3/2'>
                                    <CircularProgressbar value={percentage} text={`${percentage}%`}
                                    />
                                    <p className='flex justify-center my-2 text-white text-sm font-medium'>Energy</p>
                                </div>
                                <div className='w-3/2'>
                                    <CircularProgressbar value={percentage} text={"80%"}
                                    />
                                    <p className='flex justify-center my-2 text-white text-sm font-medium'>Fat Burn</p>
                                </div>
                                <div className='w-3/2'>
                                    <CircularProgressbar value={percentage} text={"9/10"}
                                    />
                                    <p className='flex justify-center my-2 text-white text-sm font-medium'>Strength</p>
                                </div>
                                <div className='w-3/2'>
                                    <CircularProgressbar value={percentage} text={"7/10"}
                                    />
                                    <p className='flex justify-center my-2 text-white text-sm font-medium'>Flexibility</p>
                                </div>
                                <div className='w-3/2'>
                                    <CircularProgressbar value={percentage} text={"4/10"}
                                    />
                                    <p className='flex justify-center my-2 text-white text-sm font-medium'>Endurance</p>
                                </div>
                            </div>
                            <div className='grid grid-cols-5 gap-10'>
                                <div className='w-3/2'>
                                    <CircularProgressbar value={percentage} text={"80%"}
                                    />
                                    <p className='flex justify-center text-white text-sm font-medium'>Speed</p>
                                </div>
                                <div className='w-3/2'>
                                    <CircularProgressbar value={percentage} text={`${percentage}%`}
                                    />
                                    <p className='flex justify-center text-white text-sm font-medium'>Power</p>
                                </div>
                                <div className='w-3/2'>
                                    <CircularProgressbar value={percentage} text={"9/10"}
                                    />
                                    <p className='flex justify-center text-white text-sm font-medium'>Improvement</p>
                                </div>
                                <div className='w-3/2'>
                                    <CircularProgressbar value={percentage} text={"7/10"}
                                    />
                                    <p className='flex justify-center text-white text-sm font-medium'>Regularity</p>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-row w-full justify-start items-center gap-5 ">
                            <a
                                href={`https://http://app.getactyvphysio.com/results/program/`
                                }
                                className="flex self-end mt-5 md:mt-0"
                            >
                                <p className="text-white text-xs">Share</p>
                            </a>
                            <Icon
                                icon={"akar-icons:ic_share"}
                                className="rotate-180 transform text-[#FFFFFF]"
                            />
                        </div>

                        <div className="flex flex-row w-full justify-end items-center gap-5 ">
                            <a
                                href={`https://http://app.getactyvphysio.com/results/program/`
                                }
                                className="flex self-end mt-5 md:mt-0"
                            >
                                <p className="text-white text-xs">See detailed result</p>
                            </a>
                            <Icon
                                icon={"akar-icons:chevron-down"}
                                className="rotate-180 transform text-[#FFFFFF]"
                            />
                        </div>
                    </Disclosure.Button>
                    <Disclosure.Panel className={"w-full flex flex-col"}>
                        <div className="flfex flex-col md:p-10 space-y-5">
                            <div className="flex flex-row w-full">
                                <p
                                    className={`font-medium text-xl text-primary-blue dark:text-primary-neonGreen flex basis-1/3`}
                                >
                                    Exercises
                                </p>
                                <div className="flex flex-1"></div>
                                <p
                                    className={`font-medium text-xl text-primary-blue dark:text-primary-neonGreen  basis-1/6 text-center`}
                                >
                                    Accuracy
                                </p>
                            </div>

                        </div>
                    </Disclosure.Panel>
                </div>
            </Disclosure> */}
    </div>
  );
}

export default function NewActivity({ timeline, className }) {
  console.log(timeline);
  useEffect(() => {
    console.log("useEffectActivity");
  }, []);

  console.log("NewActivity");

  return (
    <div className="md:space-y-12 space-y-60 md:pb-0 pb-40">
      {timeline ? (
        Object.keys(timeline).map((key) =>
          timeline[key].map((activity, index) => (
            <Activity {...activity} key={index} />
          ))
        )
      ) : (
        <SkeletonExerciseList />
      )}
    </div>
  );
}
